<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="6" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false"
                >{{ getPackageList.length }} Entries</small
              >
            </h5>
          </b-col>
          <b-col md="4">
            <b-button
              class="pull-right ml-1 mt-1"
              :variant="
                Filter.packageNameFilter ||
                Filter.commonFilter ||
                Filter.packageCodeFilter ||
                Filter.createdByFilter ||
                Filter.statusFilter ||
                Filter.dateRange.startDate ||
                Filter.dateRange.endDate
                  ? 'outline-danger'
                  : 'outline-primary'
              "
              :class="' ml-4' + visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              @click="visible = !visible"
              style="font-size: 0.675rem"
              >{{
                Filter.packageNameFilter ||
                Filter.commonFilter ||
                Filter.packageCodeFilter ||
                Filter.createdByFilter ||
                Filter.statusFilter ||
                Filter.dateRange.startDate ||
                Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button
            >
            <b-button
              class="pull-right ml-1 mt-1"
              v-if="getPackageList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getPackageList', 'Export As Excel')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
            <b-button
              size="sm"
              class="pull-right mt-1"
              @click="addItemCat('add', '')"
              variant="primary"
              >Add</b-button
            >
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Status</label>

                  <model-list-select
                    :list="StatusList"
                    v-model="Filter.statusFilter"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    @input="getItemPackageTempList('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker
                    :always-show-calendars="showCal"
                    v-model="Filter.dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="Filter.DFlag ? true : false"
                    @update="getItemPackageTempList('Normal', '0', '0', '1', '1')"
                  ></date-range-picker>
                </b-col>

                <b-col md="3">
                  <label>Package Name Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Package Name Filter"
                    id="packageNameFilter"
                    name="packageNameFilter"
                    autocomplete="off"
                    v-model="Filter.packageNameFilter"
                    @input="getItemPackageTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Package Code Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Package Code Filter"
                    id="packageCodeFilter"
                    name="packageCodeFilter"
                    autocomplete="off"
                    v-model="Filter.packageCodeFilter"
                    @input="getItemPackageTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Common Filter"
                    id="commonFilter"
                    name="commonFilter"
                    autocomplete="off"
                    v-model="Filter.commonFilter"
                    @input="getItemPackageTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select
                    :list="$store.getters['common/getAllUserList']"
                    id="createdByFilter"
                    @input="getItemPackageTempList('Normal', '0', '0', '1', '1')"
                    v-model="Filter.createdByFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Created User"
                  ></model-list-select>
                </b-col>
                <b-col md="12" class="mt-2">
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="ml-1 pull-right"
                    @click="clearFilter"
                    variant="outline-danger"
                    >Reset</b-button
                  >
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table
                show-empty
                stacked="md"
                responsive
                :items="getPackageList"
                :fields="itemPackageFields"
                primary-key="id_email_section"
                :per-page="pagination.perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
                class="position-relative"
              >
                <template slot="SN" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}</span>
                </template>
                <template slot="isAcitvePackage" slot-scope="row1">
                  <div v-if="adminToggle == 'Admin'" :id="'row' + row1.item.packageId">
                    <md-switch :id="'approval' + row1.item.packageId" name="approval" class="md-primary"
                      :value="row1.item.isAcitvePackage == 1 ? true : false" @change="activateItem(row1.item)">
                      <h6>
                        <br />
                        <b-badge style="margin-left: -45px">{{
                          row12.item.isActiveItem == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                      </h6>
                    </md-switch>
                  </div>
                </template>

                <template slot="raisedBy" slot-scope="row3">
                  <span v-if="row3.item.raisedBy"
                    >Raised By : {{ row3.item.raisedBy }}<br
                  /></span>
                  <span v-if="row3.item.create_date"
                    >Created Date : {{ row3.item.create_date }}<br
                  /></span>
                  <span v-if="row3.item.updatedBy"
                    >Updated By : {{ row3.item.updatedBy }}<br
                  /></span>
                  <span v-if="row3.item.update_date"
                    >Updated Date : {{ row3.item.update_date }}<br
                  /></span>

                  <b-button
                    size="sm"
                    class="ml-2"
                    @click="addItemCat('edit', row3.item)"
                    variant="primary"
                    >Edit</b-button
                  >
                </template>
              </b-table>
            </div>
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>

    <!-- Package Modal Added By Priyanshu Singh Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Package-modal"
      hide-footer
      :title="modalType+` Package`"
    >
      <b-row class="justify-content-center">
        <b-col md="4">
          <label>Package Name <span class="error">*</span></label>
          <b-form-input
            size="sm"
            :formatter="capitalizeAll"
            id="packageName"
            name="packageName"
            v-model="PackageModal.packageName"
            aria-placeholder="Please Enter Package Name"
            :style="{
              borderColor:
                !PackageModal.packageName && errorPackageList.packageName ? 'red' : '',
            }"
          ></b-form-input>
          <span class="error" v-if="!PackageModal.packageName">{{
            errorPackageList.packageName
          }}</span>
        </b-col>
        <b-col md="4">
          <label>Package Code <span class="error">*</span></label>
          <b-form-input
            size="sm"
            :formatter="capitalizeAll"
            id="packageCode"
            name="packageCode"
            aria-placeholder="Please Enter Package Code"
            v-model="PackageModal.packageCode"
            :style="{
              borderColor:
                !PackageModal.packageCode && errorPackageList.packageCode ? 'red' : '',
            }"
          ></b-form-input>
          <span class="error" v-if="!PackageModal.packageCode">{{
            errorPackageList.packageCode
          }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="my-3 text-center">
          <b-button
            :disabled="PackageDisabled"
            variant="outline-primary"
            @click="addPackage"
            id="addButtonLoader"
            size="sm"
            >Save</b-button
          >
          <b-button
            variant="outline-danger"
            class="ml-2"
            size="sm"
            @click="hidePackageModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <!-- Package Modal Added By Priyanshu Singh Start -->

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import MaintenanceService from "../../services/MaintenanceService";
import ClientUserService from "../../services/ClientUserService.js";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.$store.dispatch("setCurrentRoute", "/main/itemCatList");
    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getItemPackageTempList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() {},
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},
  data() {
    return {
      // Added vy Priyanshu Singh Start
      modalType:"Update",
      PackageDisabled: false,
      PackageModal: {
        packageId: "",
        packageName: "",
        packageCode: "",
      },
      PackageError: ["Please Enter Package Name",
       "Please Enter Package Code"
      ],
      errorPackageList: {
        packageName: "",
        packageCode: "",
      },
      // Added vy Priyanshu Singh End
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getPackageList: [],
      totalData: 0,
      itemPackageFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "packageName",
          mainkey: "packageName",
          label: "Package Name",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "packageCode",
          mainkey: "packageCode",
          label: "Package Code",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "raisedBy",
          mainkey: "raisedBy",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      StatusList: [
        {
          DVal: "0",
          DText: "In-Active",
        },
        {
          DVal: "1",
          DText: "Active",
        },
        {
          DVal: "2",
          DText: "All",
        },
      ],

      Filter: {
        packageNameFilter: "",
        commonFilter: "",
        packageCodeFilter: "",
        createdByFilter: "",
        statusFilter: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {},
  watch: {},
  methods: {
    activateItem(item) {
      this.itemObj = item;

      this.itemObj.isAcitvePackage = this.itemObj.isAcitvePackage == 1 ? 0 : 1;
      let paylod = {
        tableName: "packagemaster",
        tableId: "packageId",
        tableIsActive: "isAcitvePackage",
        value1: this.itemObj.isAcitvePackage,
        tableVal: item.packageId,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {
          console.log("Catch on Package Error: ", error);
        });
    },
    addItemCat(type, item) {
      if (item.packageName && item.packageId > 0) {
        this.modalType="Update";
        this.PackageModal = item;
      }
      this.openPackageModal();
    },

    clearFilter() {
      this.Filter = {
        packageNameFilter: "",
        commonFilter: "",
        packageCodeFilter: "",
        createdByFilter: "",
        statusFilter: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },
    // Added By Priyanshu Singh Start
    openPackageModal() {
      this.isLoading = false;
      this.$refs["Package-modal"].show();
      this.PackageDisabled = false;
    },
    hidePackageModal() {
      this.modalType="Add";
      this.PackageModal = {
        packageId: "",
        packageName: "",
        packageCode: "",
      };
      this.$refs["Package-modal"].hide();
      this.isLoading = false;
      this.PackageDisabled = false;
    },
    validatePackage() {
      let validate_new = true;
      Object.keys(this.errorPackageList).map((x, index) => {
        if (this.PackageModal[x] == "") {
          this.errorPackageList[x] = this.PackageError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addPackage() {
      this.validatePackage();
      if (this.validate != false) {
        let payload = {
          itemCode: "upsertPackage",
          packageDetDet: this.PackageModal,
        };
        MaintenanceService.getMaintenanceList(payload)
          .then((response) => {
            const { data, status, statusText } = response;

            if (status == 200 && data) {
              this.hidePackageModal();
              this.alert.content = data.MSG;
              this.PackageDisabled = false;
              this.$refs["addPop"].open();
              this.getItemPackageTempList("Normal", "0", "0", "1", "1");
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on addPackage Error: ", error);
          });
      }
    },
    // Added By Priyanshu Singh End
    getItemPackageTempList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getPackageList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getPackageList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.pagination.perPage,
        Filter: this.Filter,
      };

      MaintenanceService.getMaintenanceList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.getPackageList.length > 0) {
                this.totalData = data.totalRows;
                this.getPackageList = data.getPackageList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.lopackageDetion.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getPackageList.length > 0) {
                this.totalData = data.totalRows;
                this.getPackageList = data.getPackageList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPackageList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() {},
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getItemPackageTempList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getItemPackageTempList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getItemPackageTempList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getItemPackageTempList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// pkgMaster.vue?62e71082